module.exports = __webpack_public_path__ + "static/media/Filtro-BFV.0e65d884.pdf";